import { createAPI } from '../../common'

export default {
  getPapers: (config, vconfig = { neverLoading: false }) =>
    createAPI('customEncryptApiName-1/0nfejby.dpmvno.mbzpvu0mbzpvudpmvno0qbqfst',
      'get',
      config,
      vconfig
    ),
  getLayouts: (config, vconfig = { neverLoading: true }) =>
    createAPI('customEncryptApiName-1/0nfejby.dpmvno.mbzpvu0mbzpvudpmvno0mbzpvut',
      'get',
      config,
      vconfig
    ),
  getSubLayouts: (config, vconfig = { neverLoading: true }) =>
    createAPI('customEncryptApiName-1/0nfejby.dpmvno.mbzpvu0mbzpvudpmvno0tvcmbzpvut',
      'get',
      config,
      vconfig
    ),
  getColumns: (config, vconfig = { neverLoading: true }) =>
    createAPI('customEncryptApiName-1/0nfejby.dpmvno.mbzpvu0mbzpvudpmvno0dpmvnot',
      'get',
      config,
      vconfig
    )
}
